

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERSTATUSCOUNTBYUSERID= createAsyncThunk(
  "getUserStatsCountByUserId/getUserStatsCountByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserStatsCountByUserIdSlice = createSlice({
  name: "getUserStatsCountByUserIdSlice",
  initialState: {
    getUserStatsCountByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserStatsCountByUserId: (state) => {
        state.getUserStatsCountByUserId.loading = false
        state.getUserStatsCountByUserId.error = false
        state.getUserStatsCountByUserId.data = []
        state.getUserStatsCountByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERSTATUSCOUNTBYUSERID.fulfilled, (state, action) => {
      state.getUserStatsCountByUserId = {
        ...state.getUserStatsCountByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSTATUSCOUNTBYUSERID.pending, (state, action) => {
      state.getUserStatsCountByUserId = {
        ...state.getUserStatsCountByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERSTATUSCOUNTBYUSERID.rejected, (state, action) => {
      state.getUserStatsCountByUserId = {
        ...state.getUserStatsCountByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserStatsCountByUserIdAction = {
    GETUSERSTATUSCOUNTBYUSERID,
};

export { getUserStatsCountByUserIdAction };
export default getUserStatsCountByUserIdSlice.reducer;
export const {setInitialStateOfgetUserStatsCountByUserId} = getUserStatsCountByUserIdSlice.actions